import { combineEpics } from "redux-observable";

import apiRequestEpic$ from "./apiRequestEpic";
import getNationalitiesEpic$ from "./getNationalitiesEpic";
import getCountriesEpic$ from "./getCountriesEpic";
import getOrganizationsEpic$ from "./getOrganizationsEpic";
import getWatchListsEpic$ from "./getWatchListsEpic";
import watchListEntryEpics$ from "../features/watch-list-entry/epics";
import scoreCardsEpic$ from "../features/score-card/epics";
import logEpics$ from "../features/log/epics";
import monitoringQueueEntryEpic$ from "../features/monitoring-queue-entry/epics";
import clientProfileEpic$ from "../features/client-profile/epics";
import watchListEntryHighRiskCountriesEpics$ from "../features/watch-list-entry-high-risk-country/epics";
import watchListEntryEuTerroristsEpics$ from "../features/watch-list-entry-eu-terrorists/epics";

import logoutUserEpic$ from "./logoutUser";
// import checkUserActivityEpic$ from "./checkUserActivityEpic";
import setInitialTokenEpic$ from "./setInitialTokenEpic";
import reportEpics$ from "../features/reports/epics";
import organizationEpics$ from "../features/organization/epics";
import organizationAuthenticationEpic$ from "./organizationAuthenticationEpic";

const rootEpic = (apis) =>
  combineEpics(
    apiRequestEpic$(apis),
    getNationalitiesEpic$,
    getCountriesEpic$,
    getWatchListsEpic$,
    getOrganizationsEpic$,
    watchListEntryEpics$,
    logEpics$,
    monitoringQueueEntryEpic$,
    clientProfileEpic$,
    watchListEntryHighRiskCountriesEpics$,
    watchListEntryEuTerroristsEpics$,
    scoreCardsEpic$,
    logoutUserEpic$,
    // checkUserActivityEpic$,
    reportEpics$,
    organizationEpics$,
    setInitialTokenEpic$,
    organizationAuthenticationEpic$
  );

export default rootEpic;



// WEBPACK FOOTER //
// ./src/epics/rootEpic.js